<template>
    <div :class="[
        'single-learningpath-item-path',
    {   'last': isLastItem,
        'halfWatched': isCourseHalfWatched,
        'completed': isCourseCompleted,
        'not-logged': !isLoggedIn,
        'paragraph': isParagraphInBetweenCourses,
        'mobile': isMobileView,
        'inprogress': inProgress
    }]">
        <span  :class="['certificate-crown icon-crown', { 'completed': isCourseCompleted }]" v-if="isLearningPathCertificate"></span>
        <span class="single-learningpath-item-path__circle">
            {{ index }}
        </span>
    </div>
</template>
<script>
    export default {
        props: {
            progress: Number,
            index: Number,
            length: Number,
            courseId: Number,
            isCourseCompleted: Boolean,
            isCourseHalfWatched: Boolean,
            isLoggedIn: Boolean,
            isParagraphInBetweenCourses: Boolean,
            isLearningPathCertificate: Boolean
        },
        computed: {
            isLastItem () {
                return this.isLearningPathCertificate
            },
            inProgress () {
                return this.progress > 0 && this.progress < 100 && !this.isCourseCompleted
            }
        }
    }
</script>

<style lang="scss" scoped>
    .single-learningpath-item-path {
        position: absolute;
        top: 40%;

        &:before {
            content: '';
            position: absolute;
            top: 30px;
            right: 30px;
            height: 100px;
            bottom: 0;
            width: 3px;
            background: $silver_chalice;
            z-index: -1;

            [class*="desktop"] & {
                left: -68px;
                height: 285px;
            }
        }

        &.mobile {
            left: 8px;
            top: 8px;
            border: none;
            z-index: 0;
            &:before {
                display: none;
            }
        }

        &.halfWatched {
            .single-learningpath-item-path__circle {
                background: $amber;
            }

            &:before {
                background: $amber;
            }
        }

        &.not-logged {
            .single-learningpath-item-path__circle {
                background: $alto;
            }
        }

        &.completed {
            .single-learningpath-item-path__circle {
                background: $green;
            }
        }

        &.paragraph {
            &:before {
                [class*="desktop"] & {
                    right: 45px;
                    height: 390px;
                }
            }
        }

        &.inprogress {
            &:before {
                background: $amber;
            }
            .single-learningpath-item-path__circle {
                background: $amber;
                animation: lineAnimation 4s infinite alternate;

            }
        }

        &.not-logged {
            .single-learningpath-item-path__circle {
                background: $alto;
            }
        }

        &.completed:before {
            background: $green;
        }

        &.last:before {
            height: 0;
        }

        .icon-checked {
            position: absolute;
            right: 15px;
            color: $green;
            font-size: 3.4rem;

            [class*="desktop"] & {
                right: 30px;
            }
        }
        .certificate-crown {
            position: absolute;
            right: 25px;
            top: 4px;
            font-size: 1.9rem;
            color: $rust_orange;
            z-index: 20;

            [class*="desktop"] & {
                right: 123px;
                top: 12px;
            }

            [class*="mobile"] & {
                z-index: 100;
                font-size: 1.5rem;
                top: 3px;
            }
        }

        &__number {
            &.completed {
                position: absolute;
                right: 17px;
                top: 7px;
            }
        }

        &__circle {
            font-family: PlusJakartaSans-Medium, sans-serif;
            font-size: 2.2rem;
            color: $tuatara;
            background: $alto;
            width: 45px;
            height: 45px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            position: relative;
            z-index: 1;
            margin: 0 20px 0 0;

            &.completed {
                background: $william;
                color: $concrete;
            }

            &.in-progress {
                background: $amber;
            }

            [class*="desktop"] & {
                right: 90px;
            }

            [class*="mobile"] & {
                height: 25px;
                width: 25px;
                font-size: 1.2rem;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }
    }

    @keyframes lineAnimation {
    from {
        background-color: $silver_chalice;
    }
    to {
        background-color: $amber
    }
}
</style>
